import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _ArrowRightStopLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsxs("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: [_jsx("path", { fill: "currentColor", d: "m14 12 .354-.354.353.354-.353.354zm-10 .5a.5.5 0 0 1 0-1zm4.354-6.854 6 6-.708.708-6-6zm6 6.708-6 6-.708-.708 6-6zM14 12.5H4v-1h10z" }), _jsx("path", { stroke: "currentColor", d: "M20 5v14" })] }) });
}
const ArrowRightStopLight = forwardRef(_ArrowRightStopLight);
export { ArrowRightStopLight };
